var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTasksTabIconBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 13.125V20.625",
    stroke: "#091E42",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 16.875H18.75",
    stroke: "#091E42",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 6.875C20 6.21196 19.7366 5.57607 19.2678 5.10723C18.7989 4.63839 18.163 4.375 17.5 4.375C17.5 3.71196 17.2366 3.07607 16.7678 2.60723C16.2989 2.13839 15.663 1.875 15 1.875C14.337 1.875 13.7011 2.13839 13.2322 2.60723C12.7634 3.07607 12.5 3.71196 12.5 4.375C11.837 4.375 11.2011 4.63839 10.7322 5.10723C10.2634 5.57607 10 6.21196 10 6.875V8.125H20V6.875Z",
    stroke: "#091E42",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.875 5.625H23.125C23.4565 5.625 23.7745 5.7567 24.0089 5.99112C24.2433 6.22554 24.375 6.54348 24.375 6.875V25.625C24.375 25.9565 24.2433 26.2745 24.0089 26.5089C23.7745 26.7433 23.4565 26.875 23.125 26.875H6.875C6.54348 26.875 6.22554 26.7433 5.99112 26.5089C5.7567 26.2745 5.625 25.9565 5.625 25.625V6.875C5.625 6.54348 5.7567 6.22554 5.99112 5.99112C6.22554 5.7567 6.54348 5.625 6.875 5.625H8.125",
    stroke: "#091E42",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTasksTabIconBlack);
export default __webpack_public_path__ + "static/media/tasks_tab_icon_black.7d5a74f1a748abc3bd32f8accc8ea496.svg";
export { ForwardRef as ReactComponent };